import CircleIcon from "@mui/icons-material/Circle";
import { BoxProps, Theme } from "@mui/material";
import { isNumber } from "@mui/x-data-grid/internals";
import { isFunction, isString } from "lodash-es";
import { useCallback } from "react";

export interface StatusIndicatorProps {
  color?: string | ((theme: Theme) => string);
  size?: "small" | "medium" | "large" | number;
  sx?: BoxProps["sx"];
}

export function StatusIndicator({ color, size = "small", sx }: StatusIndicatorProps) {
  const sizeComputed = isString(size) ? size : isNumber(size) ? `${size}px` : undefined;

  const getColor = useCallback((th: Theme) => (isFunction(color) ? color(th) : color), [color]);

  return (
    <CircleIcon
      sx={{
        color: (theme) => getColor(theme),
        fontSize: sizeComputed,
        ...sx,
      }}
    />
  );
}
